import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

import { AppError, AppErrorCodes } from '@core/api';

@Component({
  selector: 'la-page-error',
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MatCardModule, MatButtonModule],
})
export class PageErrorComponent {
  @Input() error?: AppError;

  public readonly CODES = AppErrorCodes;
}
